import { Seasons } from 'common';
import Data from 'data';

const paragonTableDefault = [
  {
    name: "Core",
    stats: [
      {
        stats: ["int", "str", "dex"],
        icons: [2, 0, 1],
        amount: 5,
      },
      {
        stat: "vit",
        icon: 3,
        amount: 5,
      },
      {
        stat: "ms",
        icon: 4,
        amount: 0.5,
        decimal: 2,
        limit: 50,
        percent: true,
      },
      {
        stats: ["maxap", "maxhatred", "maxfury", "maxmana", "maxspirit", "maxwrath", "maxessence"],
        icons: [9, 7, 6, 5, 8, 10, 11],
        amounts: [0.5, 0.5, 1, 4, 1, 0.5, 1],
        decimal: 2,
        limit: 50,
      },
    ],
  },
  {
    name: "Offense",
    stats: [
      {
        stat: "ias",
        icon: 12,
        amount: 0.2,
        decimal: 2,
        limit: 50,
        percent: true,
      },
      {
        stat: "cdr",
        icon: 13,
        amount: 0.2,
        decimal: 2,
        limit: 50,
        percent: true,
      },
      {
        stat: "chc",
        icon: 14,
        amount: 0.1,
        decimal: 2,
        limit: 50,
        percent: true,
      },
      {
        stat: "chd",
        icon: 15,
        amount: 1,
        decimal: 2,
        limit: 50,
        percent: true,
      },
    ],
  },
  {
    name: "Defense",
    stats: [
      {
        stat: "life",
        icon: 16,
        amount: 0.5,
        decimal: 2,
        limit: 50,
        percent: true,
      },
      {
        stat: "armor_percent",
        icon: 17,
        amount: 0.5,
        decimal: 2,
        limit: 50,
        percent: true,
      },
      {
        stat: "resall",
        icon: 18,
        amount: 5,
        limit: 50,
      },
      {
        stat: "regen",
        icon: 19,
        amount: 214.5684,
        decimal: 1,
        limit: 50,
      },
    ],
  },
  {
    name: "Utility",
    stats: [
      {
        stat: "area",
        icon: 20,
        amount: 1,
        limit: 50,
        decimal: 2,
        percent: true,
      },
      {
        stat: "rcr",
        icon: 21,
        amount: 0.2,
        decimal: 2,
        limit: 50,
        percent: true,
      },
      {
        stat: "lph",
        icon: 22,
        amount: 160.926,
        decimal: 1,
        limit: 50,
      },
      {
        stat: "pickup",
        icon: 23,
        amount: 0.1,
        decimal: 2,
        limit: 50,
        percent: true,
      },
    ],
  },
];

const paragonTableEnmity = paragonTableDefault.map((tab) => {
  tab = {...tab};
  tab.stats = tab.stats.map(stat => {
    return {...stat, limit: 200};
  });
  return tab;
});
paragonTableEnmity[0].stats[2] = {
  stat: "extrams",
  icon: 4,
  amount: 0.125,
  decimal: 2,
  limit: 200,
  percent: true,
};

export function paragonTable(seasonal) {
  return seasonal === Seasons.Enmity ? paragonTableEnmity : paragonTableDefault;
}

export function paragonGetEmpty(table) {
  return {
    level: 0,
    data: table.map(({stats}) => stats.map(() => 0)),
  };
}

export function paragonGetInfo(info, charClass) {
  if (info.stats) {
    const index = info.stats.findIndex(stat => !Data.stats[stat].classes || Data.stats[stat].classes.includes(charClass));
    if (index < 0) return null;
    return [info.stats[index], info.amounts ? info.amounts[index] : info.amount, info.icons ? info.icons[index] : info.icon];
  } else {
    return [info.stat, info.amount, info.icon];
  }
}

export function paragonGetStats(profile) {
  const values = profile.paragon.data;
  const table = paragonTable(profile.seasonal);
  const result = {};
  for (let i = 0; i < table.length; ++i) {
    for (let j = 0; j < table[i].stats.length; ++j) {
      const info = table[i].stats[j];
      const [stat, amount] = paragonGetInfo(info, profile.class);
      result[stat] = [amount * values[i][j]];
    }
  }
  return result;
}

export function paragonGetTabPoints(tab, level) {
  return Math.floor((Math.min(level, 800) - tab + 3) / 4) + (tab === 0 ? Math.max(0, level - 800) : 0);
}

export function paragonGetTabLevel(tab, points) {
  if (points === 0) {
    return 0;
  } else if (tab === 0) {
    return (points < 200 ? points * 4 - 3 : points + 600);
  } else {
    return Math.min(points, 200) * 4 + tab - 3;
  }
}

export function paragonCanReset(table, paragon, tab) {
  const limit = table[tab].stats.reduce((sum, stat) => sum + (stat.limit || Infinity), 0);
  const available = paragonGetTabPoints(tab, paragon.level);
  const used = paragon.data[tab].reduce((sum, value) => sum + value, 0);
  return available >= limit ? used < limit : used > 0;
}

export function paragonSetLevel(table, paragon, level) {
  paragon = {...paragon, level};
  let data = paragon.data;
  for (let i = 0; i < table.length; ++i) {
    const limit = table[i].stats.reduce((sum, stat) => sum + (stat.limit || Infinity), 0);
    let available = paragonGetTabPoints(i, level);
    const used = data[i].reduce((sum, value) => sum + value, 0);
    if (used < limit && available >= limit) {
      if (data === paragon.data) data = data.slice();
      data[i] = table[i].stats.map(stat => stat.limit);
    } else if (used > available) {
      if (data === paragon.data) data = data.slice();
      const row = data[i] = data[i].slice();
      for (let j = 0; j < row.length; ++j) {
        row[j] = Math.min(row[j], available);
        available -= row[j];
      }
    }
  }
  paragon.data = data;
  return paragon;
}

export function paragonSetPoints(table, paragon, tab, index, level) {
  paragon = {...paragon};
  paragon.data = paragon.data.slice();
  paragon.data[tab] = paragon.data[tab].slice();
  paragon.data[tab][index] = level;
  const spent = paragon.data[tab].reduce((a, b) => a + b, 0);
  paragon.level = Math.max(paragon.level, paragonGetTabLevel(tab, spent));
  return paragon;
}

export function paragonAddPoints(table, paragon, tab, index, amount) {
  const points = paragonGetTabPoints(tab, paragon.level);
  const spent = paragon.data[tab].reduce((a, b) => a + b, 0);
  const value = paragon.data[tab][index];
  const limit = table[tab].stats[index].limit || Infinity;
  if (points > spent && value < limit) {
    paragon = {...paragon};
    paragon.data = paragon.data.slice();
    paragon.data[tab] = paragon.data[tab].slice();
    paragon.data[tab][index] = Math.min(limit, value + Math.min(amount, points - spent));
  }
  return paragon;
}

export function paragonResetAll(table, paragon) {
  paragon = {...paragon};
  paragon.data = paragon.data.slice();
  for (let i = 0; i < table.length; ++i) {
    const limit = table[i].stats.reduce((sum, stat) => sum + (stat.limit || Infinity), 0);
    const available = paragonGetTabPoints(i, paragon.level);
    if (available >= limit) {
      paragon.data[i] = table[i].stats.map(stat => stat.limit);
    } else {
      paragon.data[i] = table[i].stats.map(() => 0);
    }
  }
  return paragon;
}

export function paragonResetTab(table, paragon, tab) {
  paragon = {...paragon};
  paragon.data = paragon.data.slice();
  const limit = table[tab].stats.reduce((sum, stat) => sum + (stat.limit || Infinity), 0);
  const available = paragonGetTabPoints(tab, paragon.level);
  if (available >= limit) {
    paragon.data[tab] = table[tab].stats.map(stat => stat.limit);
  } else {
    paragon = {...paragon, data: paragon.data.slice()};
    paragon.data[tab] = table[tab].stats.map(() => 0);
  }
  return paragon;
}
